function advisory() {
        const textarea = document.getElementById('legal_advice_public_question_question');
        const characterCount = document.getElementById('characterCount');

        textarea.addEventListener('input', function () {
            const currentLength = this.value.length;
            characterCount.textContent = `${currentLength}/1000`;
            characterCount.style.color = currentLength > 1000 ? 'red' : '#fff';
        });

        document.querySelector('form[name="legal_advice_public_question"]').addEventListener('submit', function (e) {
            if (textarea.value.length > 1000) {
                e.preventDefault(); // Zastaví odesílání formuláře
            }
        });
}
